import { FC, memo } from "react"
import { CardType, CurrencyDto, CurrencyType } from "."
import { IOption } from "../../../types"
import { CardsItem } from "../CardsItem"
import { CryptoItem } from "../CryptoItem"
import { ExchangeSelect } from "../ExchangeSelect"
import { SelectorButton } from "../SelectorButton"

type Props = {
  isMobile: boolean
  cardType: CardType
  onCardTypeChange: (cardType: CardType) => void
  onFiatAmountChange: (amount: string) => void
  cryptoOptions: CurrencyType[]
  cryptoCurrency: CurrencyDto | null | undefined
  cryptoAmount: string
  fiatAmount: string
  onCryptoAmountChange: (amount: string) => void
  onCryptoCurrencyChange: (option: CurrencyDto) => void
  fiatOptions: CurrencyType[]
  fiatCurrency: CurrencyDto | null | undefined
  onFiatCurrencyChange: (option: CurrencyDto) => void
  onSellClick: () => void
}

const SellBlockComponent: FC<Props> = ({
  isMobile,
  cardType,
  onCardTypeChange,
  cryptoOptions,
  cryptoCurrency,
  cryptoAmount,
  fiatAmount,
  onCryptoAmountChange,
  onFiatAmountChange,
  onCryptoCurrencyChange,
  fiatOptions,
  fiatCurrency,
  onFiatCurrencyChange,
  onSellClick,
}) => {
  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
      <div
        style={{
          display: "flex",
          gap: "16px",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <ExchangeSelect
          label={!isMobile ? "You Spend" : undefined}
          buttonTitle={({ isOpen }) => (
            <SelectorButton code={cryptoCurrency?.code ?? ""} isOpen={isOpen} name={cryptoCurrency?.name ?? ""} />
          )}
          inputValue={cryptoAmount}
          onChangeInput={(x) => onCryptoAmountChange(x.target.value)}
          // @ts-ignore

          onChange={(x) => onCryptoCurrencyChange(x.meta)}
          options={cryptoOptions}
          dropDownStyle={{ overflowY: "auto" }}
          renderOption={(option: IOption<string, { name: string; rate: number }>, optionProps) => (
            <CryptoItem
              {...optionProps}
              isActive={option.value === cryptoCurrency?.code}
              key={option.value}
              name={option.meta?.name ?? ""}
              currency={option.value}
            />
          )}
        />
        {!isMobile ? <span style={{ margin: "48px 0 0", fontSize: "16px", color: "#ffffff" }}>=</span> : null}
        <ExchangeSelect
          label={!isMobile ? "You Receive" : undefined}
          buttonTitle={({ isOpen }) => (
            <SelectorButton code={fiatCurrency?.code ?? ""} isOpen={isOpen} name={cardType === "1" ? "Debit Card" : "Credit Card"} />
          )}
          inputValue={fiatAmount}
          onChangeInput={(x) => onFiatAmountChange(x.target.value)}
          onChange={() => {}}
          options={[]}
          renderDropDownHeader={({ onClose }) => (
            <CardsItem
              cardType={cardType}
              onCardTypeChange={(type) => {
                onClose()
                onCardTypeChange(type)
              }}
              currencies={fiatOptions}
              currency={fiatCurrency}
              onFiatCurrencyChange={onFiatCurrencyChange}
            />
          )}
          renderOption={() => null}
        />
      </div>

      {!isMobile ? (
        <button
          style={{
            border: "none",
            outline: "none",
            color: "#ffffff",
            height: "65px",
            borderRadius: "60px",
            padding: "0 34px",
            backgroundColor: "#E41E1F",
          }}
          onClick={onSellClick}
        >
          Sell {cryptoCurrency?.code ?? ""}
        </button>
      ) : null}
    </div>
  )
}

export const SellBlock = memo(SellBlockComponent)
